import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Message } from 'rsuite';
import { useAuth } from '../../contexts/AuthContext';

export default function RoleBasedRoute({ children, adminOnly = false, requireApprover = false, requireFinance = false, permission, anyOf }) {
  const { isLoading, isResolving, isAdmin, isApprover, isFinance, hasPermission } = useAuth();
  const location = useLocation();

  if (isLoading || isResolving) return null;

  const allowed = adminOnly
    ? isAdmin()
    : requireApprover
      ? isApprover()
      : requireFinance
        ? isFinance()
        : permission
          ? hasPermission(permission)
          : Array.isArray(anyOf) && anyOf.length > 0
            ? anyOf.some((p) => hasPermission(p))
            : true;

  if (!allowed) {
    return (
      <>
        <Message type="error" header="Access denied" showIcon>
          You do not have permission to view this page.
        </Message>
        <Navigate to="/time-off" replace state={{ from: location.pathname }} />
      </>
    );
  }

  return children;
}
